// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const image = "Captcha__image__80YgJ";
export const medium = "500";
export const regular = "400";
export const root = "Captcha__root__koGRe";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";